var loadMore = {
	init: function () {
		this.element = document.querySelector( '[data-load-more]' );

		if ( null === this.element ) {
            return;
        }

        this.progress = false;
        this.finished = false;
        this.page = 1;
		this.action = this.element.getAttribute( 'data-action');

		let trigger = document.querySelector( '[data-load-trigger="' + this.action + '"]' );
            
		if ( null !== trigger ) {
			trigger.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				this.load();

				this.element.addEventListener( 'loaded', ( e ) => {
					if ( this.finished === true ) {
						trigger.remove();
					}
				} );
			} );
		}
	},
	load: function() {
		if ( this.progress !== true && this.finished !== true ) {
            this.progress = true;

            let data = '';

            this.page = this.page + 1;
            data += 'action=' + this.action;

            data += '&page=' + this.page;

            let request = new XMLHttpRequest();
            request.open( 'GET', themeVars.ajax_url + '?' + data, true );
            request.send( null );

            request.onreadystatechange = () => {
                if ( request.readyState === 4 && request.status === 200 ) {
                    let response = JSON.parse( request.responseText );

                    if ( response.data.finished === true ) {
                        this.finished = true;
                    }

                    this.progress = false;
                    this.element.innerHTML += response.data.html;
                    this.element.dispatchEvent( new Event( 'loaded' ) );
                }
            }
        }
	}
};

export { loadMore };
